import { FC } from "react"
import { COLORS } from "shared/consts"

type ChevronRightIconProps = {
  fill?: string
}
export const ChevronRightIcon: FC<ChevronRightIconProps> = ({
                                                fill=COLORS.NEUTRAL.MUTED
                                              }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
        d="M15.5577 11.4692L10.0577 5.99976L8.99996 7.06337L13.9652 12.001L8.99996 16.9387L10.0577 18.0023L15.5577 12.5328C15.6992 12.392 15.7788 12.2007 15.7788 12.001C15.7788 11.8014 15.6992 11.61 15.5577 11.4692Z"
        fill={fill}
      />
    </svg>
  )
}